import { isMockMode, post, simulateDelay } from "../api";

export const createUpdateUsers = ({ orgId, orgUsers, successMessage }) => {
	if (isMockMode()) {
		const testData = { success: true };
		return simulateDelay(1000, () => testData);
	}

	return post(
		`OrgUsers/CreateOrUpdateOrgUsers`,
		{
			orgId,
			orgUsers,
		},
		{
			successMessage,
		}
	);
};
